/**
 * WebMCP 批量操作工具
 * 接收一系列命令，快速连续执行
 */
/* eslint-disable */
var want = require('../../unit/').want;
var t = require('../lang').t;
var actions = require('../../actions').default;
var states = require('../../control/states').default;
var delays = require('../../unit/const').delays;
var music = require('../../unit/music').music;
var store = require('../../store').default;

// 命令执行间隔（毫秒）
var COMMAND_INTERVAL = 30;

/**
 * 等待游戏解锁且新方块生成
 * @param {number} maxWait - 最大等待时间（毫秒）
 * @returns {boolean} - 是否成功解锁
 */
function waitForUnlock(maxWait) {
  var start = Date.now();
  // 等待游戏解锁 且 新方块生成（cur !== null）
  while (store.getState().get('lock') || store.getState().get('cur') === null) {
    if (Date.now() - start > maxWait) {
      return false; // 超时
    }
    // 短暂等待，避免 CPU 空转
    var now = Date.now();
    while (Date.now() - now < 10) {
      // 等待 10ms
    }
  }
  return true;
}

/**
 * 执行单个移动操作
 */
function executeMove(direction) {
  var state = store.getState();
  if (state.get('lock')) {
    return { success: false, error: t('游戏锁定', 'Game locked') };
  }

  var cur = state.get('cur');
  if (cur === null) {
    return { success: false, error: t('无活动方块', 'No active block') };
  }

  if (state.get('pause')) {
    states.pause(false);
  }

  var next;
  if (direction === 'left') {
    next = cur.left();
  } else if (direction === 'right') {
    next = cur.right();
  } else if (direction === 'down') {
    next = cur.fall();
  } else {
    return { success: false, error: t('无效方向', 'Invalid direction') };
  }

  var matrix = state.get('matrix');
  if (want(next, matrix)) {
    if (music.move) {
      music.move();
    }
    store.dispatch(actions.moveBlock(next));
    return { success: true };
  }

  return { success: false, error: t('被阻挡', 'Blocked') };
}

/**
 * 执行单个旋转操作
 */
function executeRotate() {
  var state = store.getState();
  if (state.get('lock')) {
    return { success: false, error: t('游戏锁定', 'Game locked') };
  }

  var cur = state.get('cur');
  if (cur === null) {
    return { success: false, error: t('无活动方块', 'No active block') };
  }

  if (state.get('pause')) {
    states.pause(false);
  }

  var next = cur.rotate();
  var matrix = state.get('matrix');
  if (want(next, matrix)) {
    if (music.rotate) {
      music.rotate();
    }
    store.dispatch(actions.moveBlock(next));
    return { success: true };
  }

  return { success: false, error: t('空间不足', 'Not enough space') };
}

/**
 * 执行硬降操作
 */
function executeHardDrop() {
  var state = store.getState();
  if (state.get('lock')) {
    return { success: false, error: t('游戏锁定', 'Game locked') };
  }

  var cur = state.get('cur');
  if (cur === null) {
    return { success: false, error: t('无活动方块', 'No active block') };
  }

  if (state.get('pause')) {
    states.pause(false);
  }

  if (music.fall) {
    music.fall();
  }

  var index = 0;
  var bottom = cur.fall(index);
  var matrix = state.get('matrix');

  while (want(bottom, matrix)) {
    bottom = cur.fall(index);
    index++;
  }

  var finalIndex = index - 2;
  if (finalIndex < 0) {
    finalIndex = 0;
  }
  var finalBottom = cur.fall(finalIndex);
  var shape = finalBottom.shape;
  var xy = finalBottom.xy;

  var newMatrix = matrix;
  var xyRow = xy && typeof xy.get === 'function' ? xy.get(0) : xy[0];
  var xyCol = xy && typeof xy.get === 'function' ? xy.get(1) : xy[1];

  for (var k1 = 0; k1 < shape.size; k1++) {
    for (var k2 = 0; k2 < shape.get(k1).size; k2++) {
      var n = shape.get(k1).get(k2);
      if (n && xyRow + k1 >= 0) {
        var line = newMatrix.get(xyRow + k1);
        line = line.set(xyCol + k2, 1);
        newMatrix = newMatrix.set(xyRow + k1, line);
      }
    }
  }

  store.dispatch(actions.moveBlock(finalBottom));
  store.dispatch(actions.drop(true));
  setTimeout(function() {
    store.dispatch(actions.drop(false));
  }, 100);

  // 直接执行 nextAround 的解锁逻辑，不依赖 setTimeout
  states.nextAroundForWebMCP(newMatrix);

  return { success: true };
}

/**
 * 执行暂停/继续操作
 * 注意：即使游戏锁定也允许暂停，这样在解锁后游戏会保持暂停状态
 */
function executePause(pause) {
  var state = store.getState();

  // 不检查锁定状态，允许在锁定时设置暂停

  var cur = state.get('cur');
  if (cur === null) {
    // 没有活动方块时，直接设置暂停状态
    var currentPause = state.get('pause');
    var newPause = pause !== undefined ? pause : !currentPause;
    states.pause(newPause);
    return { success: true, paused: newPause };
  }

  var currentPause = state.get('pause');
  var newPause = pause !== undefined ? pause : !currentPause;
  states.pause(newPause);

  return { success: true, paused: newPause };
}

/**
 * 执行命令序列
 * @param {Array} commands - 命令数组，每个命令是 { action: 'move'|'rotate'|'hardDrop', direction?: 'left'|'right'|'down' }
 * @returns {Object} 执行结果
 */
function executeSequence(commands) {
  var results = [];
  var failed = false;
  var failReason = '';

  for (var i = 0; i < commands.length; i++) {
    var cmd = commands[i];  // 修复：定义 cmd 变量
    var result;

    if (cmd.action === 'move') {
      result = executeMove(cmd.direction);
    } else if (cmd.action === 'rotate') {
      result = executeRotate();
    } else if (cmd.action === 'hardDrop') {
      result = executeHardDrop();
      results.push(result);

      // 硬降后等待游戏解锁再继续执行后续命令
      waitForUnlock(2000);

      // 继续执行后续命令
      continue;
    } else if (cmd.action === 'pause') {
      result = executePause(cmd.pause);
    } else {
      result = { success: false, error: t('未知命令：', 'Unknown command: ') + cmd.action };
    }

    results.push(result);

    // 如果命令失败（被阻挡），继续执行但不视为错误
    // 只有游戏锁定或无方块时才停止
    if (result.error === '游戏锁定' || result.error === '无活动方块') {
      failed = true;
      failReason = result.error;
      break;
    }

    // 非硬降操作后，等待游戏解锁再继续下一个命令
    if (cmd.action !== 'hardDrop') {
      waitForUnlock(500);
    }
  }

  return {
    success: !failed,
    executedCount: results.length,
    results: results,
    message: failed ? failReason : t('命令序列执行完成', 'Command sequence executed'),
  };
}

/**
 * WebMCP 工具定义
 */
module.exports = {
  name: 'tetris_execute_sequence',
  description: t('批量执行操作序列。用于一次性发送多个命令（移动、旋转、硬降、暂停），减少通信延迟。硬降后会自动等待游戏解锁再继续执行后续命令。', 'Execute a batch of operations (move, rotate, hard drop, pause) in one call to reduce latency. After a hard drop it waits for the game to unlock before continuing.'),
  inputSchema: {
    type: 'object',
    properties: {
      commands: {
        type: 'array',
        description: t('命令序列，每个命令是一个对象', 'Command sequence, each command is an object'),
        items: {
          type: 'object',
          properties: {
            action: {
              type: 'string',
              enum: ['move', 'rotate', 'hardDrop', 'pause'],
              description: t('操作类型', 'Action type'),
            },
            direction: {
              type: 'string',
              enum: ['left', 'right', 'down'],
              description: t('移动方向（仅 action=move 时需要）', 'Move direction (only for action=move)'),
            },
            pause: {
              type: 'boolean',
              description: t('true=暂停，false=继续，不传=切换（仅 action=pause 时可用）', 'true=pause, false=resume, omit=toggle (only for action=pause)'),
            },
          },
          required: ['action'],
        },
      },
    },
    required: ['commands'],
  },
  execute: function(args) {
    var commands = args.commands || [];
    var result = executeSequence(commands);
    return Promise.resolve({
      content: [
        {
          type: 'text',
          text: JSON.stringify(result, null, 2),
        },
      ],
    });
  },
};



// WEBPACK FOOTER //
// ./src/webmcp/tools/executeSequence.js